import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Bookmark } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import LOCard from "@/components/LOCard";

export default function Bookmarks() {
    const { t, userId, bookmarks } = useApp();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.listBookmarks(userId).then((r) => {
            setItems(r.items || []);
            setLoading(false);
        });
    }, [userId, bookmarks.length]);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 md:pb-32">
            <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="mb-6">
                <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-1">{t.bookmarks}</p>
                <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{t.bookmarks}</h1>
            </motion.div>

            {loading ? (
                <div className="text-center text-muted-foreground py-12">{t.loading}</div>
            ) : items.length === 0 ? (
                <div className="rounded-3xl bg-card border border-border/70 p-12 text-center">
                    <div className="mx-auto h-16 w-16 rounded-3xl bg-muted grid place-items-center mb-4">
                        <Bookmark className="h-7 w-7 text-muted-foreground" />
                    </div>
                    <div className="font-display font-bold text-lg mb-1">No bookmarks yet</div>
                    <div className="text-sm text-muted-foreground">Tap the bookmark icon on any LO code card to save it for later.</div>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {items.map((e, i) => <LOCard key={e.id || e.code} entry={e} index={i} />)}
                </div>
            )}
        </div>
    );
}
